import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MoreDetailsInfo } from "../../../interfaces/errorType";
import { formatJsonMessage } from "../../../../common/utilities/text";

type Props = {
  moreDetailsInfo: MoreDetailsInfo;
};

const TechnicalDetails: FC<Props> = ({ moreDetailsInfo }) => {
  const { t } = useTranslation("annotationSideControls", {
    keyPrefix: "alert.exportFailed.moreDetails",
  });

  const formattedMessage = useMemo(
    () => formatJsonMessage(moreDetailsInfo.message),
    [moreDetailsInfo.message],
  );

  return (
    <div className="error-more-details-container">
      <div className="error-more-details-line">
        <span className="error-more-details-label">{t("httpStatusCode")}</span>
        <span>{moreDetailsInfo.statusCode}</span>
      </div>
      <div className="error-more-details-line">
        <span className="error-more-details-label">{t("message")}</span>
      </div>
      <pre className="error-more-details-message">{formattedMessage}</pre>
    </div>
  );
};

export default TechnicalDetails;
